import parse from "html-react-parser";
import React from "react";
import { InlineInfoBox } from "staysure-component-library";

import { usePMIContext } from "../../../provider/private-medical-insurance.provider";

function FormDescriptionSection() {
  const { cmsData } = usePMIContext();
  const { descriptionText } = cmsData.personalMedicalQuestionArea[0];
  return (
    <div className="mt-spacing-l text-text-functional text-2xs font-normal leading-24">
      <InlineInfoBox
        content={parse(descriptionText)}
        style={{
          width: "100%",
          backgroundColor: "#EDF2FF",
          borderColor: "#006BD6",
          padding: "8px 16px 8px 16px",
          borderRadius: "8px",
          color: "#272427",
          fontSize: "16px",
          lineHeight: "24px",
        }}
      />
    </div>
  );
}

export default FormDescriptionSection;
